import React from "react";
import AircraftSelector from "../../../../../../components/common/AircraftSelector";
import "../../../../../../components/common/EditableCellGrid/EditableCellGrid.css";
import { useAircrafts } from "../../../../../../hooks/useReferenceData";

const AircraftCellEditor = ({ row, column, onRowChange, onClose }) => {
    const { aircrafts } = useAircrafts();

    return (
        <AircraftSelector
            autoFocus
            open
            allowClear
            valueType="registration"
            displayMode="detailed"
            aircrafts={aircrafts}
            className="editable-cell-editor schedule-draft-rdg-editor-select"
            value={row[column.key] || undefined}
            onChange={(value) => {
                onRowChange({ ...row, [column.key]: value || "", rawFlight: { ...(row.rawFlight || {}), aircraft_reg: value || "" } }, true);
                onClose(true, true);
            }}
            onInputKeyDown={(event) => {
                if (event.key === "Escape") {
                    event.preventDefault();
                    event.stopPropagation();
                    onClose(false, false);
                }
            }}
            onMouseDown={(event) => event.stopPropagation()}
            onClick={(event) => event.stopPropagation()}
            getPopupContainer={() => document.body}
            popupMatchSelectWidth={false}
        />
    );
};

export default AircraftCellEditor;
